import React from 'react';
import PropTypes from 'prop-types';

import { Scope } from 'informed';
import { Cell, Grid } from 'react-md';
import { get } from 'lodash-es';

import TextField from '../../Common/TextField';

import { isSIREN, isSIRET } from './utils';

const isValidSiret = (siret = '', strings = {}) => {
  const message = get(strings, 'validation.message.invalid_siret', 'Numéro de SIRET non valide');
  const status = isSIRET(siret);
  return { status, message };
};
const isValidSiren = (siren = '', strings = {}) => {
  const status = isSIREN(siren);
  const message = get(strings, 'validation.message.invalid_siren', 'Numéro de SIREN non valide');
  return { status, message };
};

const LegalPartyFieldsComponent = ({ strings, readOnly }) => (
  <Grid className="grid party">
    <div key="name" className={Cell.getClassName({ size: 6 })}>
      <Scope scope="party">
        <TextField
          className="field text"
          key="name"
          field="name"
          id="numberfield-name"
          name="name"
          shrink
          label={get(strings, 'block.covered.party.field.name.label')}
          placeholder=""
          disabled={readOnly}
          required
        />
      </Scope>
    </div>
    <div key="siren" className={Cell.getClassName({ size: 6 })}>
      <Scope scope="party">
        <TextField
          className="field text"
          key="siren"
          field="siren"
          id="siren"
          name="siren"
          shrink
          label={get(strings, 'block.covered.party.field.siren.label', 'SIREN')}
          placeholder=""
          disabled={readOnly}
          validation={isValidSiren}
        />
      </Scope>
    </div>
    <div id="siret" key="siret" className={Cell.getClassName({ size: 6 })}>
      <Scope scope="addresses[0]">
        <TextField
          className="field text"
          key="siret"
          field="siret"
          id="siret"
          name="siret"
          shrink
          label={get(strings, 'block.covered.party.field.siret.label', 'SIRET')}
          placeholder=""
          disabled={readOnly}
          validation={isValidSiret}
        />
      </Scope>
    </div>
  </Grid>
);

LegalPartyFieldsComponent.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  strings: PropTypes.object.isRequired,
  readOnly: PropTypes.bool.isRequired,
  strings: PropTypes.object, // eslint-disable-line
};

LegalPartyFieldsComponent.defaultProps = {
  strings: {},
};

export default LegalPartyFieldsComponent;
